import React, { useRef } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { useEffect } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'


const AboutUs = React.forwardRef((props, ref) => {

    useEffect(()=>{
        AOS.init({duration:2000})
    });

    const videoRef = useRef(null);

    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0; // Optional: reset the video to the start
        }
    }
 

    return (
        <>
            <Container>
                <div className="AboutUs p-3" ref={ref}>
                    <h4 className='pt-5 px-5'><span className='text-primary fs-3 fw-bold'>‘Futurristic Xperience’ FX</span> is a first-of-its-kind platform, enabling you to market your products effectively. Create engaging<span className='text-primary fs-3 fw-bold'> 3D presentations</span> that explain concepts step-by-step and bring your products to life in augmented reality just after scanning the QR, setting a new standard in product marketing. </h4>
                    <Row className="g-4 my-3">
                        <Col sm={12} md={6} lg={6}>
                          <Stack direction='vertical' className='justify-content-center align-items-center align-items-lg-end h-100' gap={3}>
                             <h3 className="fontWeight-800 w-50">Scan this QR and witness the MAGIC unfold!</h3>
                              <img src="/fexperience/assets/video/FuturristicQR.png" width={250} height={250} className="QR-image" alt="QR-code image "/>
                          </Stack>
                        </Col> 
                         <Col sm={12} md={6} lg={6}>
                          <Stack direction='vertical' className='justify-content-end align-items-start h-100' gap={3}>
                             <video loop="" height="400" width="300">
                                <source src="/fexperience/assets/video/FXMockup.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                                </video>
                         </Stack>
                         </Col>
                   </Row>
                    </div>
            </Container>
        </>
    )
});
export default AboutUs;
